import React from 'react';
import { Link } from 'react-router-dom';

const CardGlobal = (props) => {
    return (
        <Link to={`${props.link}`} className="card-golbal">
            <img src={props.image} />
            <strong>{props.title}</strong>
            <div className="tags">
                {props.tags.length == 0 ? null : props.tags.map(info =>
                    <span>{info.name}</span>
                )}
            </div>
            <div className="detailes">
                <span>{props.date}</span>
                <span><i className="icon-comment"></i>{props.comment}</span>
            </div>
        </Link>
    );
}

export default CardGlobal;